  <app-table
    class="mt-5"
    [loading]="false"
    [columns]="tableColumns"
    [data]="ballotInternalHistories"
    [pagination]="false"
    id="viewInternalHistoryTable"
  ></app-table>
